module.exports = __webpack_public_path__ + "static/eu-27d7256330253556f2f4ccc0de316f72.svg";